var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookTransparent = function SvgFacebookTransparent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    "data-name": "Group 1773"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1052"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#f5f7f8",
    "data-name": "Ellipse 46"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.238 7.75h-2a3.525 3.525 0 0 0-3.708 3.815v1.758h-2.02a.316.316 0 0 0-.315.316v2.549a.316.316 0 0 0 .315.316h2.016v6.43a.316.316 0 0 0 .315.316h2.63a.316.316 0 0 0 .315-.316v-6.43h2.357a.316.316 0 0 0 .315-.316V13.64a.316.316 0 0 0-.315-.316h-2.357v-1.492c0-.717.17-1.08 1.1-1.08h1.35a.316.316 0 0 0 .315-.316V8.069a.316.316 0 0 0-.313-.319",
    "data-name": "Path 733"
  })));
};
export default SvgFacebookTransparent;